<template>
  <div class="d-flex flex-column flex-shrink-0 p-3 bg-body-tertiary">
    <div class="logo-control">
      <a
        href="/"
        class="d-flex align-items-center mb-3 mb-md-0 me-md-auto link-body-emphasis text-decoration-none"
      >
        <img src="../../assets/logo.svg" alt="Logo" />
      </a>
    </div>

    <ul class="nav nav-pills flex-column mb-auto sidebar-menu">
      <li class="nav-item">
        <a
          href="#"
          class="nav-link"
          :class="{ active: isActiveRoute('/') }"
          @click.prevent="goToDashPage"
        >
          <i class="bi bi-grid-fill"></i>
          Dashboard
        </a>
      </li>
      <li>
        <a
          href="#"
          class="nav-link"
          :class="{ active: isActiveRoute('/plan') }"
          @click.prevent="goToPlanPage"
        >
          <i class="bi bi-play-circle-fill"></i>
          Plan
        </a>
      </li>
    </ul>

    <button @click="logout" class="btn align-items-center log-outicon">
      <strong>Logout</strong>
    </button>
  </div>
</template>

<script>
import { useRoute, useRouter } from "vue-router";

export default {
  setup() {
    const route = useRoute();
    const router = useRouter();

    const isActiveRoute = (targetPath) => {
      return (
        route.path === targetPath ||
        (targetPath === "/plan" && route.path === "/calendar")
      );
    };

    const logout = () => {
      console.log("Logging out...");
      // 实现登出逻辑
      // 清除认证令牌、更新应用状态等
      // 然后重定向到登录页面
      router.push("/login");
    };

    return { isActiveRoute, logout };
  },
  methods: {
    // ...其他方法...

    goToPlanPage() {
      this.$router.push("/plan"); // 当点击“Plan”时，导航到“/plan”页面
    },
    goToDashPage() {
      this.$router.push("/"); // 当点击“Dashboard”时，导航到“/”页面
    },

    // ...其他方法...
  },
};
</script>

<style>
.d-flex.flex-column.flex-shrink-0 {
  background-color: #ffffff !important; /* 使用 !important 确保样式生效 */
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.01); /* 在右侧添加阴影 */
}

/* 修改被访问链接的样式 */
.nav-pills .nav-link:visited {
  color: rgb(57, 56, 56) !important; /* 设置被访问后的文字颜色 */
}

/* 可以添加更多的样式来定制其他状态下的外观 */
.nav-pills .nav-link:hover,
.nav-pills .nav-link:active {
  color: #202020 !important; /* 鼠标悬停或点击时的文字颜色 */
  background-color: #f5f5f5 !important; /* 鼠标悬停或点击时的背景颜色 */
}

/* 修改活动链接的背景颜色 */
.nav-pills .nav-link.active {
  background-color: #944fff !important; /* 设置新的背景颜色 */
  color: #ffffff !important; /* 设置新的文字颜色 */
}

/* 添加平滑过渡效果 */
.nav-pills .nav-link {
  color: rgb(26, 25, 25); /* 过渡背景色和文字颜色 */
}

/* 设置图标与文字间的空间 */
.nav-link i {
  margin-right: 18px; /* 可以根据需要调整间距大小 */
}
.log-out {
  margin-bottom: 20px;
}
.logo-control {
  margin-bottom: 20px;
  margin-top: 0px;
}
/* 移除按钮和链接点击时的外边框 */
.log-outicon {
  outline: 1px solid #000000; /* 设置外框颜色和粗细 */
  padding: 3px;
}
</style>
